import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import classNames from './../../utils/classNames';

class QACollapseItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(state => Object.assign({}, state, {
            isOpen: !state.isOpen
        }));
    }

    render() {
        const { title, children, isError, titleCounters } = this.props;
        const { isOpen } = this.state;
        const arrowClassName = classNames('arrow_down', { 'active': isOpen });
        const className = classNames('person_info_item', { 'is_error': isError }, { 'active': isOpen });
        return (
            <section className={className}>
                <div onClick={this.toggle}>
                    <h3>{title}</h3>
                    <span className="cnt">{titleCounters}</span>
                    <span className={arrowClassName}></span>
                </div>
                <Collapse isOpened={isOpen}>
                    {children}
                </Collapse>
            </section>
        );
    }
}

export default QACollapseItem;


// WEBPACK FOOTER //
// ./src/components/order/QACollapseItem.js